// Custom Modal reusable
const Modal = ({ open, children }) => {
    return (
        open ? children : null
    );
};

export default Modal;